import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/tokens.css';
import './styles.css';
import './styles/base.css';
import './styles/live-analysis.css';
import './styles/ai-analysis.css';
import './styles/premium-analysis.css';
import './styles/premium-home.css';

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => registrations.forEach((registration) => registration.unregister()))
    .catch(() => {});
}

if (window.caches) {
  window.caches.keys()
    .then((keys) => Promise.all(keys.map((key) => window.caches.delete(key))))
    .catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
